import jwtDecode from 'jwt-decode';
import BraincubeHttpError from '../errors/BraincubeHttpError';
import { SCOPES } from './SCOPES';
import { addBearerToHeaders, refreshJwt } from '../network/network';
import { retrieveJwtExpirationDate } from '../storage/storage';
import { getJwt } from '../store/store';
/**
 * the threshold for JWT expiration (in milliseconds).
 */
const THRESHOLD_JWT_EXPIRATION = 2000;
function getDecodedJwt(scope) {
    const jwt = getJwt(scope);
    if (jwt) {
        try {
            return jwtDecode(jwt);
        }
        catch (e) {
            return null;
        }
    }
    return null;
}
function isPresentationMode(scope) {
    var _a, _b;
    const jwt = getDecodedJwt(scope);
    return (_b = (_a = jwt === null || jwt === void 0 ? void 0 : jwt.mode) === null || _a === void 0 ? void 0 : _a.includes('presentation')) !== null && _b !== void 0 ? _b : false;
}
function sessionStorageCleanup() {
    Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('braincube-jwt')) {
            const sessionStorageItem = sessionStorage.getItem(key);
            if (sessionStorageItem) {
                const expiration = parseInt(sessionStorageItem, 10);
                const now = Date.now();
                if (now >= expiration) {
                    sessionStorage.removeItem(key);
                }
            }
        }
    });
}
// cleanup on mount
sessionStorageCleanup();
// cleanup every 5 minutes
setInterval(sessionStorageCleanup, 50000);
/**
 * Check that the JWT is present and that it has not expired. If not => refresh
 */
function checkJwt(scope) {
    const jwtStoredExpirationDate = retrieveJwtExpirationDate(scope);
    const now = Date.now();
    if (now >= jwtStoredExpirationDate - THRESHOLD_JWT_EXPIRATION || !getJwt(scope)) {
        return refreshJwt(scope);
    }
    return Promise.resolve();
}
/**
 * Augments the basic fetch method to add the JWT header.
 * Throw a BraincubeHttpError if fetch returns a 401.
 */
function fetchWithBearerInternal(url, scope, configuration) {
    return checkJwt(scope).then(() => {
        return fetch(url, Object.assign(Object.assign({}, configuration), { headers: addBearerToHeaders(scope, configuration.headers) })).then((response) => {
            if (response.status >= 400) {
                throw new BraincubeHttpError(response);
            }
            return response;
        });
    });
}
function fetchWithProductBearer(url, configuration = {}) {
    return fetchWithBearerInternal(url, SCOPES.PRODUCT, configuration);
}
function fetchWithSiteBearer(url, configuration = {}) {
    return fetchWithBearerInternal(url, SCOPES.SITE, configuration);
}
function fetchWithBearer(url, configuration = {}) {
    return fetchWithBearerInternal(url, SCOPES.NONE, configuration);
}
export { getDecodedJwt, isPresentationMode, checkJwt, fetchWithProductBearer, fetchWithSiteBearer, fetchWithBearer };
